import "./FeaturesSubtitle.css"

export default function FeaturesSubtitle({ children }) {
    return (
        <span className="App-page-subtitle">
            {children}
        </span>
    )
}